import { React, useState } from "react";

import { useTimer } from "react-timer-hook";
import humanizeDuration from "humanize-duration";

export default function Timer(props) {
  var nextTime = (hour) => {
    const time = new Date();
    if (time.getHours() > hour) time.setDate(time.getDate() + 1);
    time.setHours(hour);
    time.setMinutes(0);
    time.setSeconds(0);
    return time;
  };

  const expiryTimestamp = nextTime();

  const midnight = useTimer({
    expiryTimestamp: nextTime(0),
    onExpire: () => {
      console.log("midnight Timer stop");

      setTimeout(() => {
        midnight.restart(nextTime(0), true);
      });
      // props.atMidnight()
    },
  });

  const seven_pm = useTimer({
    expiryTimestamp: nextTime(19),
    onExpire: () => {
      console.log("7PM Timer stop");

      setTimeout(() => {
        seven_pm.restart(nextTime(19), true);
      });
      // props.at7PM()
    },
  });

  function humanize(seconds) {
    if (seconds > 60) {
      seconds = seconds - (seconds % 60);
    }
    return humanizeDuration(seconds * 1000);
  }

  var midnight_left = humanize(midnight.totalSeconds);
  var seven_pm_left = humanize(seven_pm.totalSeconds);

  return (
    <>
      <div>{seven_pm_left} until new soduku </div>
      <div>{midnight_left} until new day </div>
    </>
  );
}
